export default __webpack_public_path__ + "static/media/regulatory--no-lane-change-to-right--g1.65211254.png";